import {
  Box,
  Typography,
  Button,
  Grid,
  FormControl,
  Autocomplete,
  TextField,
  Checkbox,
  Paper,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import React, { useState } from "react";
import { BookingTabs } from "../../shared/enums/new-booking";
import FormikSelect from "../../shared/material-ui-formik/FormikSelect";
import { ErrorMessage, Field, Formik } from "formik";
import FormikInput1 from "../../shared/material-ui-formik/FormikInput1";
import ShowInputError from "../../shared/components/ShowInputError";
import { AddBookingGuestInfoValidator } from "../../shared/validations/AdminValidator";
import { Routing } from "../../shared/constants/routing";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PlacesAutocomplete from "react-places-autocomplete";
import { geocodeByAddress } from "react-places-autocomplete";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }} className="pb-0">
          {children}
        </Box>
      )}
    </div>
  );
}

export const CorporateAddInfo = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  let {
    tabValue,
    bookingDetailsStats,
    handleChangeBooking,
    handleClearBookings,
    addCorporateInitialState,
    addGuestHandleSubmit,
    guestInfo,
    setGuestInfo,
    setSelectedCoporateInfo,
    handleTaxSelectedNew,
    searchTaxResult,
    onSearchInputChangeTaxt,
    noTaxExempt,
    handlePreviousTabChange,
    handleNextTabChange,
  } = props;

  const [address, setAddress] = useState("");

  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const handlePostalSearch = async (e) => {
    setSelectedCoporateInfo((prevState) => ({
      ...prevState,
      postal_code: e.target.value,
    }));
    if (e.target.value?.length < 4) {
      return;
    } else {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            e.target.value
          )}&key=${process.env.REACT_APP_GOOGLE_PLACES_KEY}`
        );

        const data = await response.json();

        if (data.results && data.results.length > 0) {
          const result = data.results[0];

          // Extract city, state, and country from address components
          result.address_components.forEach((component) => {
            if (component.types.includes("locality")) {
              setSelectedCoporateInfo((prevState) => ({
                ...prevState,
                city: component.long_name,
              }));
              // setCity(component.long_name);
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              setSelectedCoporateInfo((prevState) => ({
                ...prevState,
                state_id: component.long_name,
              }));
              // setState(component.long_name);
            } else if (component.types.includes("country")) {
              setSelectedCoporateInfo((prevState) => ({
                ...prevState,
                country_id: component.long_name,
              }));
              // setCountry(component.long_name);
            }
          });
        }
      } catch (error) {
        console.error("Error fetching geocoding data:", error);
      }
    }
  };

  const handleSelectAddress = async (selectedAddress) => {
    try {
      const results = await geocodeByAddress(selectedAddress);
      // const latLng = await getLatLng(results[0]);

      setAddress(selectedAddress);

      // Extract city, state, country, and postal code from address components
      results[0].address_components.forEach((component) => {
        // console.log(component, 171);

        if (component.types.includes("locality")) {
          setSelectedCoporateInfo((prevState) => ({
            ...prevState,
            city: component.long_name,
          }));
        } else if (component.types.includes("administrative_area_level_1")) {
          setSelectedCoporateInfo((prevState) => ({
            ...prevState,
            state_id: component.long_name,
          }));
        } else if (component.types.includes("country")) {
          setSelectedCoporateInfo((prevState) => ({
            ...prevState,
            country_id: component.long_name,
          }));
        } else if (component.types.includes("postal_code")) {
          setSelectedCoporateInfo((prevState) => ({
            ...prevState,
            postal_code: component.long_name,
          }));
        }
      });
      setSelectedCoporateInfo((prevState) => ({
        ...prevState,
        address: selectedAddress,
      }));
    } catch (error) {
      console.error("Error selecting address:", error);
    }
  };

  const addCorporateHandleSubmit = (values) => {};

  return (
    <TabPanel value={tabValue} index={BookingTabs.AddInfo}>
      {/* <AddInfo /> */}
      <Grid
        container
        spacing={2}
        alignItems="end"
        sx={{
          position: "sticky",
          top: { sm: "61px", xs: "170px" } ,
          zIndex: "1111",
        }}
      >
        <Grid item md={12} sm={12} xs={12}>
          <div
            style={{
              display: "flex",
              // background: "#38e078",
              background: "#382DAE",
              border: "1px solid #F2F2F2",
              borderRadius: "6px",
              // width: "97%",
              height: "auto",
              justifyContent: "space-between",
              alignItems: "center",
              // color: "#FFFFFF",
              padding: "10px 10px",
            }}
          >
            {tabValue !== BookingTabs.BookRoom ? (
              <ArrowBackIosIcon
                onClick={() => handlePreviousTabChange(tabValue)}
                style={{
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                  color: "#382DAE",
                  padding: "5px 0px 5px 10px",
                  borderRadius: "6px",
                  boxSizing: "content-box",
                }}
              />
            ) : (
              <div></div>
            )}
            <h1
              style={{
                color: "#ffffff",
                fontSize: "18px",
                fontWeight: "500",
                lineHeight: "unset",
              }}
            >
              {t("Booking details")}: {bookingDetailsStats.noOfRooms}{" "}
              {t("room(s)")} | {bookingDetailsStats.noOfAdults} {t("adult(s)")},{" "}
              {bookingDetailsStats.noOfChild} {t("child(ren)")} | $
              {Number(bookingDetailsStats.finslTotal).toFixed(2)} |{" "}
              {Number(bookingDetailsStats.noOfRooms) > 0 && (
                <>
                  <span
                    onClick={handleChangeBooking}
                    style={{
                      color: "#2499D1",
                      cursor: "pointer",
                    }}
                  >
                    {t("Change")}
                  </span>{" "}
                  |{" "}
                  <span
                    onClick={handleClearBookings}
                    style={{
                      color: "#DD4B39",
                      cursor: "pointer",
                    }}
                  >
                    {t("Clear")}
                  </span>
                </>
              )}
            </h1>
            {tabValue !== BookingTabs.Confirm ? (
              <ArrowForwardIosIcon
                onClick={() => handleNextTabChange(tabValue)}
                style={{
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                  color: "#382DAE",
                  padding: "5px",
                  borderRadius: "6px",
                  boxSizing: "content-box",
                }}
              />
            ) : (
              <div></div>
            )}
          </div>
        </Grid>
      </Grid>
      <div className="p-2">
        <h6 className="mb-1">{t("Coporate Guest")}</h6>
        <Formik
          initialValues={addCorporateInitialState}
          onSubmit={addCorporateHandleSubmit}
          validateOnBlur={true}
          validateOnChange={true}
          enableReinitialize={true}
          //   validationSchema={() => AddBookingGuestInfoValidator(t)}
        >
          {(props) => {
            const { handleSubmit } = props;
            return (
              <form onSubmit={handleSubmit} noValidate>
                <Grid container spacing={2} alignItems="flex-start">
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Company Profile Name")}
                      name="company_profile_name"
                      id="company_profile_name"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage
                      name="company_profile_name"
                      component={ShowInputError}
                    />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Corporete ID")}
                      name="corporate_id"
                      id="corporate_id"
                      readOnly
                      component={FormikInput1}
                    />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Contact Name")}
                      name="contact_name"
                      id="contact_name"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage
                      name="contact_name"
                      component={ShowInputError}
                    />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Contact Title")}
                      name="contact_title"
                      id="contact_title"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage
                      name="contact_title"
                      component={ShowInputError}
                    />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Email")}
                      name="email"
                      id="email"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage name="email" component={ShowInputError} />
                  </Grid>
                  <Grid
                    item
                    lg={1.4}
                    md={3}
                    xs={12}
                    sx={{ top: { md: "-3px" } }}
                  >
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Phone")}
                    </Typography>
                    <PhoneInput
                      country={"us"}
                      enableSearch={true}
                      value={props?.values?.phone_code}
                      onChange={(phone) => {
                        // setPhoneCode(`+${phone}`);
                      }}
                      specialLabel=""
                      inputStyle={{
                        width: "100%",
                        border: "1px solid #B4ADAD !important",
                        borderRadius: "6px !important",
                        height: "50px",
                      }}
                      inputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item lg={2.6} md={3} xs={12}>
                    <Field
                      className={"mt-md-3"}
                      name="phone"
                      id="phone"
                      component={FormikInput1}
                    />
                    {/* <ErrorMessage style={{top:'20px', left:"25px"}} name="phone" component={ShowInputError} /> */}
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Fax")}
                      name="fax"
                      id="fax"
                      component={FormikInput1}
                    />
                    <ErrorMessage name="fax" component={ShowInputError} />
                  </Grid>
                  {!noTaxExempt && (
                    <>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        // marginRight: "-90px",
                        borderTop: "2px solid",
                      }}
                    ></div>
                    </Grid>
                    <Grid
                      item
                      lg={4}
                      md={4}
                      sm={12}
                      xs={12}
                      style={{
                        marginTop: props?.values?.tax_exempt ? "30px" : "0",
                      }}
                    >
                      <Field
                        label={t("Tax Exempt")}
                        name="tax_exempt"
                        id="tax_exempt"
                        type="checkbox"
                        onChange={async (e) => {
                          // setTax_exempt_num(0);
                          const { checked } = e.target;

                          if (checked) {
                            setGuestInfo((prevState) => ({
                              ...prevState,
                              tax_exempt: 1,
                            }));
                            props.setFieldValue(`tax_exempt`, 1);
                          } else {
                            setGuestInfo((prevState) => ({
                              ...prevState,
                              tax_exempt: 0,
                            }));
                            props.setFieldValue(`tax_exempt`, 0);
                            // handleTaxSelected([]);
                            handleTaxSelectedNew([]);
                            setGuestInfo((prevState) => ({
                              ...prevState,
                              tax_id_data: [],
                            }));
                          }
                        }}
                        checked={props.values.tax_exempt === 1 ? true : false}
                        component={Checkbox}
                      />
                      {t("Tax Exempt")}
                    </Grid>
                    </>
                  )}
                  {guestInfo.tax_exempt === 1 && (
                    <>
                      <Grid item lg={4} md={4} sm={12} xs={12}>
                        <Field
                          label={t("Tax Exempt code")}
                          name="tax_exempt_num"
                          placeHolder="Tax Exempt Code"
                          // maxLength={150}
                          onBlur={async (e) => {
                            setGuestInfo((prevState) => ({
                              ...prevState,
                              tax_exempt_num: e.target.value,
                            }));
                          }}
                          component={FormikInput1}
                          readOnly
                        />
                        <ErrorMessage
                          name="tax_exempt_num"
                          component={ShowInputError}
                        />
                      </Grid>
                      <Grid item lg={4} md={4} sm={12} xs={12}>
                        <Typography
                          id="font-600"
                          style={{
                            marginBottom: "11px",
                            color: "rgb(30, 30, 30)",
                            fontSize: "16px",
                            lineHeight: "24px",
                          }}
                        >
                          {t("Tax ID")}
                        </Typography>
                        <FormControl fullWidth>
                          <Autocomplete
                            id="combo-box-demo"
                            size="small"
                            sx={{ padding: "3px" }}
                            // name= "tax_id"
                            options={searchTaxResult.filter(
                              (item) => item?.is_exempt_tax === 1
                            )}
                            onClick={onSearchInputChangeTaxt}
                            multiple={true}
                            // readOnly={tax_exempt_num === 123456 ? false : true}
                            onChange={(event, value) => {
                              handleTaxSelectedNew(value);
                              setGuestInfo((prevState) => ({
                                ...prevState,
                                tax_id_data: value,
                              }));
                              // console.log(1791,'v', value)
                            }}
                            value={guestInfo?.tax_id_data || []}
                            getOptionLabel={(option) => option?.name || ""}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("Exempt Tax")}
                                variant="outlined"
                              />
                            )}
                          />
                        </FormControl>

                        <ErrorMessage
                          name="Tax Id"
                          component={ShowInputError}
                        />
                      </Grid>
                      {/* } */}
                    </>
                  )}

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        // marginRight: "-90px",
                        borderTop: "2px solid",
                      }}
                    ></div>
                  </Grid>
                  {/* <Grid item lg={4} xs={12} md={6}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                      }}
                    >
                      {t("Default Rate Plan")}
                    </Typography>

                    <Field
                      label={t("Select Default Rate Plan")}
                      name="default_rate_plan_id"
                      id="default_rate_plan_id"
                    //   options={rateTypes?.map((data1) => ({
                    //     title: data1.name,
                    //     value: data1.id,
                    //   }))}
                      component={FormikSelect}
                    />
                    <ErrorMessage
                      name="default_rate_plan_id"
                      component={ShowInputError}
                    />
                  </Grid> */}

                  <Grid item lg={4} xs={12} md={6}>
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "rgb(30, 30, 30)",
                        fontSize: "16px",
                        lineHeight: "24px",
                        fontWeight: 500,
                      }}
                    >
                      {t("Search By Google")}
                    </Typography>
                    <PlacesAutocomplete
                    //   value={address}
                      value={""}
                    //   onChange={setAddress}
                    //   onSelect={(e) => handleSelectAddress(e)}
                      disabled
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div>
                          <input
                            {...getInputProps({
                              placeholder: t("Search Places ..."),
                              className: "location-search-input",
                            })}
                            style={{
                              padding: "14px",
                              border: "1px solid #B4ADAD",
                              color: "#255480",
                              borderRadius: "6px",
                              width: "100%",
                              position: "relative",
                            }}
                          />
                          <div
                            className="autocomplete-dropdown-container"
                            style={{
                              position: "absolute",
                              outline: "none",
                              zIndex: "1",
                              listStyle: "none",
                              padding: "0",
                              margin: "10px 0 10px -1px",
                              boxShadow: "1px 2px 18px rgba(0,0,0,0.25)",
                              backgroundColor: "white",
                              width: "100%",
                              maxHeight: "220px",
                              overflowY: "scroll",
                              borderRadius: "7px",
                            }}
                          >
                            {loading && (
                              <div
                                style={{
                                  padding: "5px",
                                  borderBottom: "1px solid #fafafa",
                                }}
                              >
                                {t("Loading...")}
                              </div>
                            )}
                            {suggestions.map((suggestion) => {
                              const className = suggestion.active
                                ? "suggestion-item--active"
                                : "suggestion-item";
                              // inline style for demonstration purpose
                              const style = suggestion.active
                                ? {
                                    backgroundColor: "#fafafa",
                                    cursor: "pointer",
                                    padding: "5px",
                                    borderBottom: "1px solid #fafafa",
                                  }
                                : {
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                    padding: "5px",
                                    borderBottom: "1px solid #fafafa",
                                  };
                              return (
                                <div
                                  key={suggestion.placeId}
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Address")}
                      placeHolder={t("Enter Address")}
                      name="address"
                      id="address"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage name="address" component={ShowInputError} />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Country")}
                      name="country_id"
                      id="country_id"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage
                      name="country_id"
                      component={ShowInputError}
                    />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("State")}
                      name="state_id"
                      id="state_id"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage name="state_id" component={ShowInputError} />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("City")}
                      name="city"
                      id="city"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage name="city" component={ShowInputError} />
                  </Grid>
                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Postal Code")}
                      placeHolder={t("Postal Code")}
                      name="postal_code"
                      id="postal_code"
                      onChange={(e) => handlePostalSearch(e)}
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage
                      name="postal_code"
                      component={ShowInputError}
                    />
                  </Grid>

                  <Grid item lg={4} xs={12} md={6}>
                    <Field
                      label={t("Notes")}
                      name="notes"
                      id="notes"
                      component={FormikInput1}
                      readOnly
                    />
                    <ErrorMessage name="notes" component={ShowInputError} />
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </div>
    </TabPanel>
  );
};
